import Apify from '@module/apify';

export default Apify({
  getAccount: {
    path: '/api/v4/accounts/{accountId}',
    method: 'GET',
    pathExt: true,
  },

  editAccount: {
    path: '/api/v4/accounts/{accountId}',
    pathExt: true,
    method: 'PUT',
  },

  createSubdomain: {
    path: '/api/v4/accounts/{accountId}/subdomains',
    pathExt: true,
    method: 'POST',
  },

  removeTeamMember: {
    path: '/api/v4/memberships/{membershipId}',
    pathExt: true,
    method: 'DELETE',
  },

  updateTeamMember: {
    path: '/api/v4/memberships/{membershipId}',
    method: 'PUT',
    pathExt: true,
  },

  validate: {
    path: '/api/v4/accounts/validate',
    method: 'POST',
  },

  validateSignup: {
    path: '/api/v4/accounts/signup/validate',
    method: 'POST',
  },

  validateSubdomain: {
    path: '/api/v4/accounts/subdomains/validate',
    method: 'POST',
  },

  getLastOrder: {
    path: '/api/v4/subscriptions/{subscriptionId}/order',
    method: 'GET',
    pathExt: true,
  },

  completeLastOrder: {
    path: '/api/v4/subscriptions/{subscriptionId}/order',
    method: 'PUT',
    pathExt: true,
  },

  getPaypalRedirect: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/complete',
    method: 'POST',
    pathExt: true,
  },

  getCheckoutDetails: {
    path: '/api/v4/subscriptions/{subscriptionId}/checkout',
    method: 'GET',
    pathExt: true,
  },

  getSubscriptionDetails: {
    path: '/api/v4/subscriptions/{subscriptionId}',
    pathExt: true,
    method: 'GET',
  },

  updateSubscription: {
    path: '/api/v4/subscriptions/{subscriptionId}',
    method: 'PATCH',
    pathExt: true,
  },

  renewSubscription: {
    path: '/api/v4/subscriptions/{subscriptionId}/renew',
    method: 'POST',
    pathExt: true,
  },

  cancelSubscription: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/cancel',
    method: 'PUT',
    pathExt: true,
  },

  reactivateSubscription: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/reactivate',
    method: 'PUT',
    pathExt: true,
  },

  duplicateSubscription: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/duplicate',
    method: 'POST',
    pathExt: true,
  },

  uploadWallpaper: {
    path: '/api/v4/images/thumbs/wallpapers',
    method: 'POST',
  },

  uploadEmailBackground: {
    path: '/api/v4/images/thumbs/email_backgrounds',
    method: 'POST',
  },
});
